// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".file {\n  font-size: 0.9rem;\n}", "",{"version":3,"sources":["webpack://./src/app/components/user-management/user-profile-edit/user-profile-edit.component.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;AADF","sourcesContent":["@import \"../../../../variables\";\n\n.file{\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
